import { render, staticRenderFns } from "./CoozzyBookmarkIcon.vue?vue&type=template&id=ab519eda&scoped=true"
import script from "./CoozzyBookmarkIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBookmarkIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBookmarkIcon.vue?vue&type=style&index=0&id=ab519eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab519eda",
  null
  
)

export default component.exports